
const DEFAULTFIELDS = [
  {
    id: 'first_name',
    lock: false,
    type: 'string',
    title: "Applicant's First Name",
    widget: {
      type: 'charfield'
    },
    default: false,
    internal: false,
    required: true,
    list_view: false,
    enable_ocr: false,
    full_width: false,
    conditional: false,
    description: '',
    search_enable: '',
    source_fields: [],
    system_generated: false
  },
  {
    id: 'last_name',
    lock: false,
    type: 'string',
    title: "Applicant's Last Name",
    widget: {
      type: 'charfield'
    },
    default: false,
    internal: false,
    required: true,
    list_view: false,
    enable_ocr: false,
    full_width: false,
    conditional: false,
    description: '',
    search_enable: '',
    source_fields: [],
    system_generated: false
  },
  {
    id: 'email',
    lock: false,
    type: 'string',
    title: "Applicant's Email Address",
    widget: {
      type: 'charfield'
    },
    default: false,
    internal: false,
    required: false,
    list_view: false,
    enable_ocr: false,
    full_width: false,
    conditional: false,
    description: '',
    search_enable: '',
    source_fields: [],
    system_generated: false
  },
  {
    id: 'phone',
    lock: false,
    type: 'telephone',
    title: "Applicant's Phone Number",
    widget: {
      type: 'charfield'
    },
    default: false,
    internal: false,
    required: true,
    list_view: false,
    enable_ocr: false,
    full_width: false,
    conditional: false,
    description: '',
    search_enable: '',
    source_fields: [],
    system_generated: false
  },
  {
    id: 'designation',
    lock: false,
    type: 'string',
    title: 'Designation',
    widget: {
      type: 'charfield'
    },
    default: false,
    internal: false,
    required: true,
    list_view: false,
    enable_ocr: false,
    full_width: false,
    conditional: false,
    description: '',
    search_enable: '',
    source_fields: [],
    system_generated: false
  },
  {
    id: 'application_type',
    lock: false,
    type: 'select',
    title: 'Application Type',
    values: [
      {
        key: 'New',
        value: 'New'
      },
      {
        key: 'Renewal',
        value: 'Renewal'
      }
    ],
    widget: {
      type: 'dropdown'
    },
    default: false,
    internal: false,
    required: true,
    list_view: false,
    enable_ocr: false,
    full_width: false,
    conditional: false,
    description: '',
    search_enable: '',
    source_fields: [],
    system_generated: false
  }
  // {
  //   id: 'renewal_period',
  //   lock: false,
  //   type: 'number',
  //   title: 'Renewal Period (In Days)',
  //   widget: {
  //     type: 'charfield'
  //   },
  //   default: false,
  //   internal: false,
  //   required: false,
  //   list_view: false,
  //   enable_ocr: false,
  //   full_width: false,
  //   conditional: false,
  //   description: '',
  //   search_enable: '',
  //   source_fields: [],
  //   system_generated: false
  // }
];

export default DEFAULTFIELDS;
